

















































import { Component, Mixins, Prop } from 'vue-property-decorator'

import PostApi from '../../../../../../../../../plugins/AdminTemplate/includes/logic/Api/PostApi'
import RowButtonView from '../../../../../../components/NodeButtonsView/RowButtonView.vue'
import NodeMessagePreview from '../../../../../../components/SampleNodeComponents/NodeMessagePreview.vue'
import { Target } from '../../../../../Editor/types'
import { SampleNodeMixin } from '../../../../index'
import { InfoLimitedSubscriptionNode } from '../../logic/InfoLimitedSubscriptionNode'

@Component({
  data() {
    return {
      PostApi,
    }
  },
  components: {
    NodeMessagePreview,
    RowButtonView
  }
})
export default class InfoLimitedSubscriptionSampleNode extends Mixins(SampleNodeMixin) {
  @Prop() node!: InfoLimitedSubscriptionNode

  get currentChannel(): Target | undefined {
    return this.node.nodeProps.targets().find((t) => t.id === this.node.data.target)
  }
}
